import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Select from 'react-select'
class MultiSelectField extends Component {

	static propTypes = {
		label: PropTypes.string,
		placeholder: PropTypes.string,
		options: PropTypes.array,
		onChange: PropTypes.func.isRequired
	}

	onChange = (value) => {
    	const { onChange = () => void 0 } = this.props
		onChange(value)
	}

	render () {
    	const { placeholder, options } = this.props
		const { value, onChange } = this.props

		const customStyles = {
			control: (base, state) => ({...base,
				'&:hover': { borderColor: '#CCCCCC' },
				...(state.isFocused && { borderColor: '#CCCCCC' }),
				boxShadow: 'none',
				borderRadius: 0
			}),
			menu: (base, state) => ({...base,
				marginTop: -1,
				borderRadius: '0',
				border: '1px solid #CCCCCC',
				boxShadow: 'none'
			}),
			menuList: (base, state) => ({...base, marginTop: '0px'}),
			option: (base, state) => ({...base,
				color: '#202020',
				':active': { backgroundColor: '#D4EDF1'},
				...(state.isFocused && {backgroundColor: '#E8E8E8'})
			}),
			placeholder: (base, state) => ({...base, '&&:hover': { color: 'black' } })
		}

		return (
			<Select
				styles={customStyles}
				closeOnSelect={false}
				isMulti={true}
				onChange={onChange}
				options={options}
				isClearable={true}
				placeholder={placeholder}
				closeMenuOnSelect={false}
				value={value}
			/>
		)
	}
}
export default MultiSelectField



// WEBPACK FOOTER //
// ./src/components/multiselect.js